import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import axios from 'axios';
import {
  ACCESSIBLE_CHANNEL_TYPE_PLAYLIST,
  API_BASE_URL,
  ENDPOINTS,
  USER_ROLES,
} from '../app.config';
import Utils from '../app.utilities';
import { CompanyService } from '../company.service';
import * as LinkedList from 'linked-list'
import { UserInfoService } from '../shared/user-info.service';
import { TranslateService } from '@ngx-translate/core';

const utilities = new Utils();

@Component({
  selector: 'app-playlist-edit',
  templateUrl: './playlist-edit.component.html',
  styleUrls: ['./playlist-edit.component.css'],
  // Is already provided in ../app.module.ts
  //  but the UserInfoService, in the constructor, needs access to ActivatedRoute.params
  //  https://stackoverflow.com/questions/39977962/angular-2-0-2-activatedroute-is-empty-in-a-service
  providers: [UserInfoService]
})
export class PlaylistEditComponent implements OnInit {
  route: ActivatedRoute;
  companyService: CompanyService;
  toaster: ToasterService;
  baseUrl: string;
  companyName: string;
  userRole: string;
  duration: number;
  refresh_interval: number | null;
  banner: string;
  bannerSize: number = 150;
  bannerOpacity: number = 50;
  theme: string;
  weather: boolean = true;
  date: boolean = true;
  hour: boolean = true;
  totalDuration: number;
  prefferedDuration: number;
  assetsForRemoval: any;
  playlist: any;
  assets: any;
  sub: any;
  companyId: any;
  playlistId: any;
  assetSelected: any;
  errorFields: any;
  orderingInProgress: boolean;
  dragItem: any;
  options: any;
  showChart: boolean;
  chart : any;
  totalPlaylistDuration : number = 0;
  playlistAssetsTemplateTypeDuration : any[] = [];
  playlistAssetsWebsiteTypeDuration : any[] = [];
  playlistAssetsWebsiteSubtypeDuration : any[] = [];
  businesOwnerName : string;
  businessOwnerIdLocalStorage = localStorage.getItem('businessOwnerId');

  // Messages
  asset_list_selected: string;
  successfully_added: string;
  error_adding: string;
  playlist_successfully_copied: string;
  error_playlist_copied: string;
  blank: string;
  top: string;
  right: string;
  bottom: string;
  left: string;
  dark: string;
  light: string;
  weatherLabel: string;
  dateLabel: string;
  timeLabel: string;
  assetValue: string;
  assetRadio = {
    weather: 'weather',
    date: 'date',
    hour: 'hour'
  };

  constructor(
    route: ActivatedRoute,
    companyService: CompanyService,
    toaster: ToasterService,
    private router: Router,
    private userInfoService : UserInfoService,
    private translate: TranslateService
  ) {
    this.route = route;
    this.companyService = companyService;
    this.toaster = toaster;
  }

  initializeForm() {
    this.banner = 'blank';
    this.bannerSize = 150;
    this.bannerOpacity = 50;
    this.theme = this.generateTheme();
    this.assetSelected = null;
    this.duration = null;
    this.refresh_interval = null;
    this.weather = this.date = this.hour = true;
    this.assetValue = 'weather';
    this.errorFields = [];
  }

  ngOnInit() {
    let _self = this;
    this.assets = [];
    this.orderingInProgress = false;
    this.baseUrl = API_BASE_URL;
    this.assetsForRemoval = [];
    this.totalDuration = 0;
    this.initializeForm();
    this.showChart = false;
    this.sub = this.route.params.subscribe(params => {
      this.companyId = params.companyId;
      this.playlistId = params.playlistId;
      this.companyService.setCompanyId(this.companyId);
      this.getUserInfo();
    });

    this.options = {
      chart: {
        type: 'bar',
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: [],
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Playlist timeline(s)',
        },
      },
      legend: {
        reversed: true,
      },
      plotOptions: {
        series: {
          stacking: 'normal',
          events: {
            click : function(e) {
              _self.onChartSelection(this);
              return false;
            },
            legendItemClick: function(e) {
              _self.onChartSelection(this);
              return false;
            }
          }
        },
      },
      series: [],
      credits: false
    };
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });

    this.route.data
      .subscribe((data) => {
        _self.playlist = data.playlist;
        _self.prefferedDuration = this.getPrefferedDurationFromStr(_self.playlist.preferred_duration);
        _self.options.title.text = _self.playlist.name;
        _self.options.xAxis.categories = [_self.playlist.name];
        _self.generateChartSeries(_self.playlist.playlist_assets);
        _self.showChart = true;
        _self.startAssetsPropertiesDurationCalculation();
      });

    this.assetValue = 'weather';

    // Messages translations
    this.translate.stream('SHARED.Messages.asset_list_selected').subscribe((res: string) => {
      this.asset_list_selected = res;
    });
    this.translate.stream('SHARED.Messages.successfully_added').subscribe((res: string) => {
      this.successfully_added = res;
    });
    this.translate.stream('SHARED.Messages.error_adding').subscribe((res: string) => {
      this.error_adding = res;
    });
    this.translate.stream('SHARED.Messages.playlist_successfully_copied').subscribe((res: string) => {
      this.playlist_successfully_copied = res;
    });
    this.translate.stream('SHARED.Messages.error_playlist_copied').subscribe((res: string) => {
      this.error_playlist_copied = res;
    });
    this.translate.stream('PLAYLIST_EDIT_PAGE.Form.Banner.no').subscribe((res: string) => {
      this.blank = res;
    });
    this.translate.stream('PLAYLIST_EDIT_PAGE.Form.Banner.top').subscribe((res: string) => {
      this.top = res;
    });
    this.translate.stream('PLAYLIST_EDIT_PAGE.Form.Banner.right').subscribe((res: string) => {
      this.right = res;
    });
    this.translate.stream('PLAYLIST_EDIT_PAGE.Form.Banner.bottom').subscribe((res: string) => {
      this.bottom = res;
    });
    this.translate.stream('PLAYLIST_EDIT_PAGE.Form.Banner.left').subscribe((res: string) => {
      this.left = res;
    });
    this.translate.stream('PLAYLIST_EDIT_PAGE.Form.Theme.dark').subscribe((res: string) => {
      this.dark = res;
    });
    this.translate.stream('PLAYLIST_EDIT_PAGE.Form.Theme.light').subscribe((res: string) => {
      this.light = res;
    });
    this.translate.stream('PLAYLIST_EDIT_PAGE.Form.weather').subscribe((res: string) => {
      this.weatherLabel = res;
    });
    this.translate.stream('PLAYLIST_EDIT_PAGE.Form.date').subscribe((res: string) => {
      this.dateLabel = res;
    });
    this.translate.stream('PLAYLIST_EDIT_PAGE.Form.time').subscribe((res: string) => {
      this.timeLabel = res;
    });
  }

  startAssetsPropertiesDurationCalculation(){

    if( this.calculateDuration() ){
      this.totalPlaylistDuration = this.calculateDuration()
    } else {
      // reset
      this.playlistAssetsTemplateTypeDuration = [];
      this.playlistAssetsWebsiteTypeDuration = [];
      this.playlistAssetsWebsiteSubtypeDuration = [];
      return
    }

    this.playlistAssetsTemplateTypeDuration = this.calcPlaylistDurationProperyBased({
      property : "template_type",
      values   : [
        "image",
        "video",
        "html_video",
        "slideshow",
        "currency_exchange_list",
        "metals_exchange_list",
        ,"led",
        "html",
        "html_link",
        "fixed_html_video"
      ]
    });
    this.playlistAssetsWebsiteTypeDuration = this.calcPlaylistDurationProperyBased({
        property : "content_type",
        values   : ["Komercialno", "Info"]
    })
    this.playlistAssetsWebsiteSubtypeDuration = this.calcPlaylistDurationProperyBased({
        property : "subtype",
        values   : ["PR", "Novica"]
    });
  }

  calcPlaylistDurationProperyBased( assetProps) {
    // Storage
    var storage = {};
    assetProps.values.forEach( (value) => {
      storage[value] = {
        name       : value,
        duration   : null,
        percentage : null
      }
    });

    // Durations storage
    this.playlist.playlist_assets.forEach( (pAsset) => {
      // storage["html_link"]
      storage[pAsset.asset[assetProps.property] ].duration += pAsset.duration;
    })

    // Cleaning
    // remove unused values from storage
      // if a playlist asset(playlist_assets[0].asset) doesn't have that property
      // specified in assetProps.values
      // examples: video, html_link in assetProps.property
    for ( const storageKey in storage ){
      if(!storage[storageKey].duration) {
        delete storage[storageKey]
      }
    }

    // Percentage calcs
    let getPercentageOf = (nr, total) => {
      return Math.round(nr / total * 100);
    }
    for( const storageKey in storage) {
      storage[storageKey].percentage = getPercentageOf(storage[storageKey].duration, this.totalPlaylistDuration);
    }

    // Response with built structure
    let arrayStorage = [];
    for( const storageKey in storage) {
      arrayStorage.push(storage[storageKey])
    }
    // Add total
    arrayStorage.push({
      /*name       : "SKUPAJ:",*/
      name       : 'TOTAL:',
      duration   : this.totalPlaylistDuration,
      percentage : 100
    })

    return arrayStorage
  }

  filterAssets() {
    const arr = [];
    if (this.assets) {
      for (const asset of this.assets) {
        if (asset.status === 'completed') {
          arr.push(asset);
        }
      }
    }
    return arr;
  }

  openAsset(url, assetStatus) {
    if (assetStatus && assetStatus === 'completed') {
      window.open(url, '_blank');
    }
  }

  getAssets() {
    const _self = this;
    axios
      .get(ENDPOINTS.ASSETS.replace(':companyId', this.companyId))
      .then(response => {
        const totalAssets = response.headers.total;
        axios
          .get(
            ENDPOINTS.ASSETS.replace(':companyId', this.companyId) +
              '?per_page=' +
              totalAssets,
          )
          .then(responseTotal => {
            _self.assets = responseTotal.data;
          });
      });
  }

  connectChannels(playlistId) {
    for (const channel of this.playlist.channels) {
      axios.post(ENDPOINTS.CHANNEL_ACCESS, {
        accessible_id: playlistId,
        accessible_type: ACCESSIBLE_CHANNEL_TYPE_PLAYLIST,
        channel_id: channel.id,
      });
    }
  }

  generateChartSeries(assets) {
    const _self = this;

    let addChartData = () => {
      // let reversedAssets = assets.slice().reverse();
      let reversedAssets = [...assets].reverse();
      reversedAssets.forEach(asset => {
        _self.options.series.push({
          id: asset.id,
          name: asset.asset.name,
          data: [asset.duration],
          _colorIndex : _self.getAssetChartColor(asset.asset.template_type)
        });
      });
    }

    // reset if they are already set
    if(_self.options.series.length) {
      _self.options.series.length = 0;
    }
    setTimeout(addChartData, 1500);

  }

  getAssetChartColor(template_type){
    // CSS are defined in ../../styles.css starting at line 3129
    let color;
    switch (template_type) {
      case "image":
        color = 1
        break;
      case "video":
        color = 2
        break;
      case "html_video":
        color = 3
        break;
      case "slideshow":
        color = 4
        break;
      case "currency_exchange_list":
        color = 5
        break;
      case "metals_exchange_list":
        color = 6
        break;
      case "led":
        color = 7
        break;
      case "html":
        color = 8
        break;
      case "html_link":
        color = 9
        break;
      case "fixed_html_video":
        color = 10
        break;
    } // switch
    return color;
  }

  onChartSelection(chartElement) {
    let chartElName = chartElement.name;
    let clickedAsset = this.playlist.playlist_assets.find( asset => {
	     return asset.asset.name === chartElName;
    });
    let fullUrl = this.baseUrl + clickedAsset.template_url.replace('/', '');
    this.openAsset(fullUrl, clickedAsset.asset.status);
  }

  getPlaylistInfo() {
    const _self = this;
    axios
      .get(
        ENDPOINTS.PLAYLIST.replace(':companyId', this.companyId) +
          '/' +
          this.playlistId,
      )
      .then(response => {
        _self.playlist = response.data;
        _self.prefferedDuration = this.getPrefferedDurationFromStr(_self.playlist.preferred_duration);
        _self.options.title.text = _self.playlist.name;
        _self.options.xAxis.categories = [_self.playlist.name];
        _self.generateChartSeries(_self.playlist.playlist_assets);
        _self.showChart = true;
        _self.startAssetsPropertiesDurationCalculation();
      });
  }

  getPrefferedDurationFromStr(duration: string): number {
    if (!duration) {
      return 0;
    }

    const tokens = duration.split(' ');
    const numberReg = /^[0-9]+/;
    const unitReg = /[a-z]$/;

    let seconds = 0;

    for (const rep of tokens) {
      const repNumberArray = numberReg.exec(rep);
      const repUnitArray = unitReg.exec(rep);

      let repNumber = 0;
      let repUnit = '';

      if (repNumberArray.length > 0) {
        repNumber = +repNumberArray[0];
      }

      if (repUnitArray.length > 0) {
        repUnit = repUnitArray[0];
      }

      switch (repUnit) {
        case 's':
          seconds += repNumber;
          break;
        case 'm':
          seconds += repNumber * 60;
          break;
        case 'h':
          seconds += repNumber * 60 * 60;
          break;
        default:
          break;
      }
    }

    return seconds;
  }

  getCompanyInfo() {

  }

  getUserInfo() {
    const _self = this;

    this.userInfoService.getInformations()
    .subscribe( info => {
      _self.businessOwnerIdLocalStorage = localStorage.getItem('businessOwnerId');
      _self.userRole   = info.userRole;
      _self.companyName = info.companyName;
      _self.businesOwnerName = info.businesOwnerName;

      if (
        _self.userRole !== USER_ROLES.COMPANY_VIEWER &&
        _self.userRole !== USER_ROLES.COMPANY_EDITOR
      ) {
        _self.getAssets();
      }

    });

  }

  validateOpacity(opacity){
    if(typeof opacity === "number"){
      if( opacity % 1 !== 0 ) {
        this.bannerOpacity = Math.round(opacity);
        return;
      }
      // only allow values from 0 to 100
      if( !(opacity >= 0 && opacity <= 100) ){
          // reset to default
          this.bannerOpacity = 50;
      }
    } else {
      // reset to default
      this.bannerOpacity = 50;
    }
  }

  autocompleteFormatter(data: any) {
    return `${data.id}. ${data.name} [${data.template_type}]`;
  }

  autocompleteListFormatter(data: any) {
    return `${data.name} [${data.template_type}]`;
  }

  generatePostObject() {
    let weather = this.isExchangeList() ? true : this.weather;
    let date = this.date;
    let time = this.hour;
    if (this.assetSelected.template_type === 'led') {
      if (this.assetValue === this.assetRadio.weather) {
        weather = true;
        date = false;
        time = false;
      } else {
        if (this.assetValue === this.assetRadio.date) {
          weather = false;
          date = true;
          time = false;
        } else {
          if (this.assetValue === this.assetRadio.hour) {
            weather = false;
            date = false;
            time = true;
          }
        }
      }
    }
    return {
      playlist_id: this.playlistId,
      asset_id: this.assetSelected.id,
      position: 0,
      banner: this.banner,
      banner_size: this.bannerSize || null,
      banner_opacity: this.bannerOpacity / 100,
      theme : this.theme,
      include_date: date,
      include_time: time,
      include_weather: weather,
      duration: this.duration,
      html_link_refresh_time: this.refresh_interval,
    };
  }

  generateTheme(){
      let theme;
      if(this.assetSelected){
        theme = this.assetSelected.template_type === 'html_link' ? 'bright' : 'dark';
      } else {
        theme = 'dark';
      }
      return this.theme = theme;
  }

  addPlaylistAsset() {
    const _self = this;
    this.errorFields = [];
    if (!this.duration && this.assetSelected.template_type != 'video') {
      // setting duration field on HTML Video asset is disabled
      if(this.assetSelected.template_type !== 'html_video' && this.assetSelected.template_type !== 'fixed_html_video') {
        this.errorFields.push('duration');
      }
    }
    if (!this.assetSelected) {
      this.errorFields.push('asset');
    }
    if (this.playlist.asset_list && this.playlist.playlist_assets.length > 0) {
      this.errorFields.push('asset_list');
      this.toaster.pop('error', this.asset_list_selected);
    }
    // optional template_type refresh_interval
    // if ( !this.refresh_interval && this.assetSelected.template_type === 'html_link') {
    //   this.errorFields.push('refresh_interval');
    // }
    if (this.errorFields.length === 0) {
      axios.post(ENDPOINTS.PLAYLIST_ASSET, this.generatePostObject()).then(
        response => {
          _self.getPlaylistInfo();
          _self.initializeForm();
          _self.toaster.pop('success', this.successfully_added);
        },
        error => {
          _self.toaster.pop('error', this.error_adding);
        },
      );
    }
  }

  updatePlaylistAsset(asset, endpointPath) {
    const _self = this;

    if(endpointPath === "pathAsset" ) {
      // Update assset.name, asset.content_type, asset.subtype
      axios
        .put(
          // difference from ./media.component.ts line: 400 is asset.id, here is asset.asset.id
          ENDPOINTS.ASSETS.replace(':companyId', this.companyId) + '/' + asset.asset.id,
          asset,
        )
        .then(
          response => {
            _self.generateChartSeries(_self.playlist.playlist_assets);
            _self.startAssetsPropertiesDurationCalculation();
          },
          error => {
          },
        );
    } else {
      // endpointPath === "pathPlaylistAsset" or endpointPath === undefined
      // Update asset.duration
      axios.put(ENDPOINTS.PLAYLIST_ASSET + '/' + asset.id, asset).then(
        response => {
          _self.generateChartSeries(_self.playlist.playlist_assets);
          _self.startAssetsPropertiesDurationCalculation();
        },
        error => {

        },
      );
    }



  }

  generateBannerString(asset) {
    const result = [];
    const banners = {
      blank: this.blank,
      top: this.top,
      bottom: this.bottom,
      left: this.left,
      right: this.right,
    };
    const themes = {
      dark: this.dark,
      bright: this.light,
    };
    if (asset.banner) {
      result.push(banners[asset.banner]);
    }
    if (asset.theme) {
      result.push(themes[asset.theme]);
    }
    if (asset.include_date) {
      result.push(this.dateLabel);
    }
    if (asset.include_time) {
      result.push(this.timeLabel);
    }
    if (asset.include_weather) {
      result.push(this.weatherLabel);
    }
    if (asset.banner !== 'blank') {
      result.push(`${asset.banner_size} px`)
    }
    if (asset.banner_opacity) {
      result.push(`${asset.banner_opacity * 100}%`)
    }
    return result.join(', ');
  }

  calculateDuration() {
    let totalDuration = 0;
    if (this.playlist && this.playlist.playlist_assets.length) {
      const playlistAssets = this.playlist.playlist_assets;
      for (const asset of playlistAssets) {
        totalDuration += asset.duration;
      }
    }
    return totalDuration;
  }

  toggleAssetRemoval(assetId) {
    if (this.assetsForRemoval.includes(assetId)) {
      this.assetsForRemoval.splice(this.assetsForRemoval.indexOf(assetId), 1);
    } else {
      this.assetsForRemoval.push(assetId);
    }
  }

  removeAssets() {
    const _self = this;
    axios
      .delete(
        ENDPOINTS.PLAYLIST_ASSET +
          '?playlist_id=' +
          this.playlistId +
          '&ids=' +
          this.assetsForRemoval,
      )
      .then(response => {
        _self.assetsForRemoval = [];
        _self.getPlaylistInfo();
      });
  }

  orderAsset(asset, position, continueWith?: () => void, disablePlaylistReload?: boolean) {
    if (this.orderingInProgress) {
      return;
    }
    this.orderingInProgress = true;
    const _self = this;
    axios
      .patch(ENDPOINTS.PLAYLIST_ASSET + '/' + asset.id, {
        playlist_id: parseInt(this.playlistId, 10),
        position,
      })
      .then(
        res => {
          _self.orderingInProgress = false;

          if (! disablePlaylistReload) {
            _self.getPlaylistInfo();
          }

          continueWith && continueWith()
        },
        error => {
          _self.orderingInProgress = false;
        },
      );
  }

  viewSlideshow() {
    window.open(
      '/slideshow/' + this.playlistId + '/company/' + this.companyId,
      '_blank',
    );
  }

  copyPlaylist() {
    const _self = this;
    axios
      .post(
        ENDPOINTS.COPY_PLAYLIST
          .replace(':companyId', this.companyId)
          .replace(':playlistId', this.playlistId),
      )
      .then(
        response => {
          _self.getPlaylistInfo();
          _self.connectChannels(response.data.id);
          _self.toaster.pop('success', this.playlist_successfully_copied);
        },
        error => {
          _self.toaster.pop('error', this.error_playlist_copied);
        },
      );
  }
  isExchangeList(): boolean {
    return this.assetSelected && (this.assetSelected.template_type == 'metals_exchange_list' || this.assetSelected.template_type == 'currency_exchange_list')
  }

  updatePlaylistSynchronization() {
    const _self = this;

    axios
      .patch(
        ENDPOINTS.UPDATE_PLAYLIST
          .replace(':companyId', this.companyId)
          .replace(':playlistId', this.playlistId), {
            id: this.playlistId,
            editing: _self.playlist.editing,
          }
      )
      .then(response => {
        _self.getPlaylistInfo();
      }, error => {
        _self.toaster.pop('error', this.error_playlist_copied);
      });
  }

  updatePlaylistPreferredDuration() {
    const _self = this;

    axios
      .patch(
        ENDPOINTS.UPDATE_PLAYLIST
          .replace(':companyId', this.companyId)
          .replace(':playlistId', this.playlistId), {
            id: this.playlistId,
            preferred_duration: `${_self.prefferedDuration}`,
          }
      )
      .then(response => {
        _self.getPlaylistInfo();
      }, error => {
        _self.toaster.pop('error', this.error_playlist_copied);
      });
  }

  startDrag(item: any) {
    this.dragItem = item;
  }

  endDrag() {
    this.dragItem = null;
  }

  releaseDrop(sourceAsset: any, targetAsset: any, targetOffset: number) {
    if (this.orderingInProgress) {
      return;
    }

    const self = this;

    if (sourceAsset && targetAsset) {
      let assets = this.playlist.playlist_assets as Array<any> //Array.from(this.playlist.playlist_assets as Array<any>);
      const sourceIndex = assets.findIndex(x => x.id == sourceAsset.id);
      const targetIndex = assets.findIndex(x => x.id == targetAsset.id);
      const targetAssetPosition = targetAsset.position;
      sourceAsset = assets[sourceIndex];

      self.orderingInProgress = true;

      const allAssetsDone = new Array<boolean>(assets.length)

      let addAmout = 0;

      if (sourceIndex > targetIndex) {
        addAmout = 1;
      }

      assets.splice(targetIndex + targetOffset, 0, assets[sourceIndex]);
      assets.splice(sourceIndex + addAmout, 1)

      for (let i = 0; i < assets.length; i++) {
        const asset = assets[i];
        const index = i;
        asset.position = i + 1;
      }

      axios
      .patch(ENDPOINTS.PLAYLIST_ASSET + '/' + sourceAsset.id, {
        playlist_id: parseInt(this.playlistId, 10),
        position: sourceAsset.position,
      })
      .then(
        res => {
          self.orderingInProgress = false;
        },
        error => {
          self.orderingInProgress = false;
        },
      );
    }

    this.endDrag()
  }

  releaseDropUp(sourceAsset: any, targetAsset: any) {
    this.releaseDrop(sourceAsset, targetAsset, 0)
  }

  releaseDropDown(sourceAsset: any, targetAsset: any) {
    this.releaseDrop(sourceAsset, targetAsset, 1)
  }

  onAssetSelect(){
    this.generateTheme()
  }

  onBannerSelect(){
    this.generateTheme()
  }

}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/playlist-edit/playlist-edit.component.ts